// eslint-disable-next-line no-shadow
export enum DriverScreens {
  DriverOrders = 'DriverOrders',
  OrderDetails = 'OrderDetails',
  DeliveryDetails = 'DeliveryDetails',
  Signature = 'Signature',
  MapOverview = 'MapOverview',
  LoadVanAt = 'LoadVanAt',
  PrintScanBarcodes = 'PrintScanBarcodes',
  ScanBarcode = 'ScanBarcode',
}
